import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Popup } from "semantic-ui-react";
import Only from "react-only-when";
import styles from "./styles.less";

class Amenity extends Component {
  renderIcon = ({ ...params }) => {
    const { isRtl, includeName } = this.props;
    const { iconCode, text } = params;
    return (
      <div
        className={cx(styles.amenity, { [styles.includeName]: includeName })}
      >
        <span
          className={cx(styles.icon, `icon-amenetie`, `icon-${iconCode}`, {
            [styles.rtl]: isRtl
          })}
        />
        <Only when={includeName}>
          <div>{text}</div>
        </Only>
      </div>
    );
  };

  renderAmenity = () => {
    const { isRtl, code, name, includeName } = this.props;
    const amenityContent = name || code;
    const popUpContent = amenityContent;
    if (includeName) {
      return this.renderIcon({ iconCode: code, text: amenityContent });
    } else {
      return (
        <Popup
          inverted
          content={popUpContent}
          className={cx(styles.popup, { [styles.rtl]: isRtl })}
          position={isRtl ? "top left" : "top right"}
          trigger={this.renderIcon({ iconCode: code, text: amenityContent })}
        />
      );
    }
  };

  render() {
    return this.renderAmenity();
  }
}

Amenity.propTypes = {
  isRtl: PropTypes.bool,
  name: PropTypes.string,
  code: PropTypes.string,
  includeName: PropTypes.bool
};

export default Amenity;



// WEBPACK FOOTER //
// ./src/components/common/Amenities/Amenity/Amenity.js